import { Box } from '@mui/material'
import MainLayout from '../../components/MainLayout'
import SetPasswordWizzard from '../../components/wizards/SetPasswordWizzard'

const SetPasswordPage: React.FC = () => {
  return (
    <MainLayout className={'t-login-view'}>
      <Box sx={{ maxWidth: '442px', width: '100%' }}>
        <SetPasswordWizzard />
      </Box>
    </MainLayout>
  )
}

export default SetPasswordPage
